import { useTranslation } from 'react-i18next';
import SplashScreen from '@/components/common/SplashScreen';

/** Visiteur non connecté sur un lien personnel de régie : l'accès est refusé, pas différé. */
export default function StaffLinkSignedOut() {
  const { t } = useTranslation('webinars');
  return <SplashScreen label={t('staffLink.signedOut')} fullscreen />;
}
